var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chat-image-preview" }, [
    _c("div", { staticClass: "post-image" }, [
      _vm.image
        ? _c("img", {
            attrs: { src: _vm.image, alt: _vm.title },
            on: { click: _vm.handleViewImage }
          })
        : _c(
            "div",
            { staticClass: "post-placeholder" },
            [_c("InlineSvg", { attrs: { src: "/images/icons/ic-image.svg" } })],
            1
          )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "action-buttons" }, [
      _c(
        "div",
        {
          staticClass: "action-button share-button",
          on: { click: _vm.onShare }
        },
        [
          _c("span", [_vm._v("Share")]),
          _vm._v(" "),
          _c("InlineSvg", { attrs: { src: "/images/icons-2025/share.svg" } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "action-button download-button",
          on: { click: _vm.onDownload }
        },
        [
          _c("InlineSvg", { attrs: { src: "/images/icons-2025/download.svg" } })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }